<template>
  <div class="w-full relative flex flex-col items-center justify-center h-72 md:h-128">
    <img src="../../images/copertina_studente.jpg" class="object-cover w-full h-72 md:h-128
      md-image" v-if="isTeacher">
    <img src="../../images/copertina_studente.jpg" class="object-cover w-full h-72 md:h-128
      md-image" v-else>
    <div class="bg-gradient-to-b absolute bottom-0 h-32
      md:h-48 w-full opacity-70"
      :class="isTeacher ? 'from-beige-academy-300 to-beige-academy-250' :
      'from-orange-academy-300 to-orange-academy-100'">
    </div>
    <button v-if="user.urlProfilePhoto" class="absolute group transform
      hover:scale-110" @click="openImageBig">
      <div class="relative">
        <img :src="user.urlProfilePhoto"
          class="w-28 md:w-40 lg:w-48 rounded-lg mt-20 lg:mt-12">
        <button class="absolute right-0 top-0 border border-white p-1 rounded
           opacity-0 group-hover:opacity-100" @click="openImageModal(user.id)">
          <edit-icon class="text-white w-3" />
        </button>
      </div>
    </button>
    <button v-else class="border-dashed border-4 border-gray-600 bg-white
      absolute w-48 h-48 opacity-90 mt-20 lg:mt-28"
      @click="openImageModal(user.id)">
        {{$t('dashboard.profile-photo')}}
    </button>
    <h1 class="md:text-2xl text-lg uppercase absolute bottom-16 z-60 font-medium text-white
    tracking-wide"
      :class="isTeacher ? 'text-black' : 'text-white'">
        {{ user.name }}
    </h1>
    <h2 class="text-lg absolute bottom-3 z-60 text-white">
      {{ isTeacher ? user.teacher.title : user.student.qualification }} </h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import EditIcon from './EditIcon.vue';
import ImageBig from './ImageBig.vue';

export default {
  components: { EditIcon },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    openImageBig() {
      this.$modal.show(ImageBig, {
        givenUser: this.user,
      }, { adaptive: true, height: 'auto' });
    },
  },

};
</script>
